import { createFileRoute } from '@tanstack/react-router'

import { PaymentPlansView } from '@/components/Internal/Finance/PaymentPlansView'

export const Route = createFileRoute(
  '/internal/system/administration/payment-plans',
)({
  component: PaymentPlansView,
})
